import { render, staticRenderFns } from "./FormViewItem.vue?vue&type=template&id=2a4e6488&scoped=true"
import script from "./FormViewItem.vue?vue&type=script&lang=js"
export * from "./FormViewItem.vue?vue&type=script&lang=js"
import style0 from "./FormViewItem.vue?vue&type=style&index=0&id=2a4e6488&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4e6488",
  null
  
)

export default component.exports